<template>
  <div class="swiper-card card-question">
    <div class="corner-radius-blur"></div>
    <!-- <h4 v-if="slide.byline">{{ slide.byline }}</h4> -->
    <div class="onboarding-content">
      <svg width="50" height="44" viewBox="0 0 50 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.002 4.71429C34.3359 4.71429 31.8262 6.00089 30.2637 8.17143L26.9043 12.8464C26.4648 13.4554 25.7617 13.8187 25.0098 13.8187C24.2578 13.8187 23.5547 13.4554 23.1152 12.8464L19.7559 8.17143C18.1934 6.00089 15.6836 4.71429 13.0176 4.71429C8.42773 4.71429 4.70703 8.45625 4.70703 13.0723C4.70703 16.1268 5.91797 19.1223 7.68555 22H12.0703C12.373 22 12.6562 21.8232 12.7832 21.5384L15.8594 14.742C16.2305 13.9268 17.0312 13.3866 17.9199 13.3571C18.8086 13.3277 19.6484 13.8188 20.0586 14.6143L25.1758 24.3277L29.2773 17.6295C29.707 16.9223 30.4883 16.4902 31.3086 16.5098C32.1289 16.5295 32.8906 16.9714 33.3008 17.6982L35.5078 21.6071C35.6445 21.8527 35.9082 22 36.1816 22H42.3242C44.0918 19.1321 45.3027 16.1268 45.3027 13.0723C45.3027 8.45625 41.582 4.71429 36.9922 4.71429H37.002ZM42.9688 26.7143H36.1914C34.2285 26.7143 32.4219 25.6536 31.4453 23.9446L31.1816 23.483L27.002 30.3089C26.5625 31.0259 25.7715 31.458 24.9316 31.4286C24.0918 31.3991 23.3301 30.9277 22.9395 30.1714L18.1445 21.0571L17.041 23.4929C16.1523 25.4571 14.209 26.7143 12.0605 26.7143H5.16602C2.44141 22.8741 0 18.2089 0 13.0723C0 5.85357 5.82031 0 12.998 0C17.168 0 21.0938 2.01339 23.5352 5.41161L25 7.44464L26.4648 5.41161C28.9062 2.01339 32.832 0 37.002 0C44.1797 0 50 5.85357 50 13.0723C50 18.2089 47.5586 22.8741 44.8438 26.7143H42.9688ZM8.88672 31.4286H15.2832C18.2715 34.483 21.3281 37.0857 23.6426 38.8732C23.9551 39.1089 24.4141 39.2857 25.0098 39.2857C25.6055 39.2857 26.0645 39.1089 26.377 38.8732C28.6914 37.0955 31.748 34.483 34.7363 31.4286H41.1328C37.0801 36.1036 32.4707 40.1205 29.2285 42.6152C28.0273 43.5384 26.543 44 25.0195 44C23.4961 44 22.0117 43.5384 20.8105 42.6152C17.5391 40.1205 12.9395 36.1036 8.88672 31.4286Z" fill="#FFDE00"/>
      </svg>
      <h3>{{ slide.title }}</h3>

      <div class="score-container">
        <div
          class="drag-overlay"
          ref="scoreBar"
          @mousedown="startDrag"
          @touchstart="startDrag"
        ></div>
        <div class="score-bar">
          <div class="score-progress" :style="`width: ${(score / 11) * 100}%`" :class=" {'red' : score <= 3, 'amber' : score >= 4 && score <=7, 'green' : score > 7}"></div>
        </div>

        <div class="score">
          <div
            v-for="number in 10"
            :key="number"
            class="item"
            :class="{'selected' : number === score}"
          >
            <span>{{ number }}</span>
            <div
              class="mark"
              :class="{'red' : number <= 3, 'amber' : number >= 4 && number <=7, 'green' : number > 7}"
              v-if="score === number"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="labels">
      <span :class="{'red' : score > 0 && score <= 3}">Bad</span>
      <span :class="{'amber' : score >= 4 && score <=7}">Fine</span>
      <span :class="{'green' : score > 7}">Good</span>
    </div>

    <div v-show="score > 0" class="message">
      <div v-show="this.score <= 3">
        <p><span class="yellow">Thanks for being honest</span> — and honestly, this is why we built Nourish. Let's work together to help you feel better about the news.</p>
      </div>

      <div v-show="this.score >= 4 && this.score <= 7">
        <p><span class="yellow">Thanks</span> — this is why we built Nourish. Let's work together to help you feel better about the news.</p>
      </div>

      <div v-show="this.score > 7">
        <p><span class="green">Thanks for sharing</span>. That's a great position<br>for us to start from!</p>
      </div>
    </div>

    <!-- <button v-if="score > 0" class="next" @click="next()">Next</button> -->
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        score: 0,
        isDragging: false,
      }
    },

    methods: {
      startDrag(event) {
        this.isDragging = true;
        this.updateScoreFromEvent(event);

        window.addEventListener('mousemove', this.onDrag);
        window.addEventListener('mouseup', this.stopDrag);
        window.addEventListener('touchmove', this.onDrag);
        window.addEventListener('touchend', this.stopDrag);
      },

      onDrag(event) {
        if (this.isDragging) {
          this.updateScoreFromEvent(event);
        }
      },

      stopDrag() {
        this.isDragging = false;
        window.removeEventListener('mousemove', this.onDrag);
        window.removeEventListener('mouseup', this.stopDrag);
        window.removeEventListener('touchmove', this.onDrag);
        window.removeEventListener('touchend', this.stopDrag);
      },

      updateScoreFromEvent(event) {
        this.$emit('swiperUpdate')

        setTimeout(() => {}, 150)

        const bar = this.$refs.scoreBar;
        const rect = bar.getBoundingClientRect();
        const clientX = event.touches ? event.touches[0].clientX : event.clientX;
        const relativeX = clientX - rect.left;
        const percentage = Math.max(0, Math.min(1, relativeX / rect.width));
        const calculatedScore = Math.round(percentage * 10); // scores 1 to 10

        this.score = Math.max(1, Math.min(10, calculatedScore));
        this.$userEngine.setOnboardMemo({
          news_score: this.score,
        });
        this.$emit('enableNextAction');
      },

      next() {
        this.$emit('next');
      }
    },

    // watch: {
    //   '$route.params.stack': {
    //     handler(slug) {
    //       if (slug === this.slide.slug) {
    //         this.$emit('swiperUpdate')
    //       }
    //     },
    //     immediate: true,
    //   },
    // }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-question {
    display: flex;
    flex-direction: column;
    max-width: 550px;
    margin: 0 auto;
    padding: 2rem 0;

    .onboarding-content {
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;

      .desktop & {
        align-items: center;
      }

      svg path {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $yellow-tone-3;
        }
      }
    }

    h3 {
      font-family: 'Brawler';
      font-weight: normal;
      font-size: 38px;
      line-height: 110%;
      text-align: left;

      .desktop & {
        font-size: 50px;
        text-align: center;
        margin-bottom: 1.5rem;
      }
    }

    h4 {
      font-size: 16px;
      text-align: center;
      font-weight: normal;
      margin-bottom: 1rem;
      color: $yellow-tone-4;

      .darkmode & {
        color: $yellow-tone-3;
      }
    }
    
    .score-container {
      position: relative;
      margin-top: 1rem;
      height: 60px;
      width: 100%;
    }

    .drag-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 30;
      cursor: grab;
    }

    .score-bar {
      background: rgba($neutral-400, 0.07);
      border-radius: 500px;
      height: 60px;
      z-index: 5;
      position: relative;
      overflow: hidden;

      .darkmode & {
        background: rgba($neutral-100, 0.25);
      }

      .score-progress {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        border-top-left-radius: 500px;
        border-bottom-left-radius: 500px;
        z-index: 1;
        transition: width 0.3s ease;

        &.red {
          background: rgba($red-tone-3, 0.2);
        }

        &.amber {
          background: rgba($orange-tone-3, 0.2);
        }

        &.green {
          background: rgba($green-tone-3, 0.2);
        }
      }
    }

    .score {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: -60px;
      position: relative;
      z-index: 10;
      height: 100%;
      padding: 0 0.5rem;

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 10%;
        text-align: center;
        z-index: 10;
        height: 100%;

        span {
          position: relative;
          z-index: 20;
        }

        .mark {
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 28px;
          height: calc(100% + 20px);
          border-radius: 500px;
          z-index: 15;

          &.red {
            background: $red-tone-3;
          }

          &.amber {
            background: $orange-tone-3;
          }

          &.green {
            background: $green-tone-3;
          }
        }
      }
    }

    .labels {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0 1.1rem;
      margin-top: 1rem;

      span {
        text-align: center;
        color: $neutral-400;
        
        &.first-child {
          text-align: left;
        }

        &.last-child {
          text-align: right;
        }

        &.red,
        &.amber,
        &.green {
          font-weight: bold;
        }

        &.red {
          color: $red-tone-3;

          .darkmode & {
            color: $red-tone-2;
          }
        }

        &.amber {
          color: $orange-tone-3;

          .darkmode & {
            color: $orange-tone-2;
          }
        }

        &.green {
          color: $green-tone-3;

          .darkmode & {
            color: $green-tone-2;
          }
        }
      }
    }

    .message {
      line-height: 150%;
      font-size: 16px;
      text-align: left;
      margin-top: 3rem;

      .desktop & {
        text-align: center;
        max-width: 400px;
        margin: 3rem auto 0 auto;
      }

      p {
        margin-bottom: 1rem;
      }

      .green {
        font-weight: bold;
        color: $green-tone-3;

        .darkmode & {
          color: $green-tone-2;
        }
      }

      .yellow {
        font-weight: bold;
        color: $yellow-tone-4;

        .darkmode & {
          color: $yellow-tone-3;
        }
      }
    }
  }
</style>